export const getIsoDate = (date: Date) => date.toISOString().split('T')[0]
